export const shopButtonId = 'sidechef-shop-button'
export const shopButtonIdForExt = 'sidechef-shop-button-ext'
export const substitutionButtonId = 'sidechef-substitution-button'
export const substitutionButtonIdForExt = 'sidechef-substitution-button-ext'
export const widgetMountFlag = 'data-sidechef-shop-button-mounted'
export const defaultLanguage = 'en'
export const defaultPartnerKey = 'sc'
export const buttonIframeElementId = 'sc_shop_buttons_iframe'
export const suButtonIframeElementId = 'sc_substitution_button_iframe'
export const shopButtonDataAttribute = 'data-sidechef-shop-button'
export const multiButtonHrefDataAttribute = 'data-sidechef-href'
export const partnerKeyDataAttribute = 'data-partner-key'
export const disablePoweredByPopupDataAttribute = 'data-disable-powered-by-popup'
export const widgetAdId = 'sidechef-widget-ad'
export const widgetBroadcastEventType = 'SideChef/ShopButton/WIDGET_EVENT'
export const flippSiteId = '1252469'
export const flippZoneId = '292544'
export const flippSlotId = 'flipp-ux-slot-ec375a'
export const flippScriptSrc = `https://cdn-gateflipp.flippback.com/tag/js/flipptag.js?site_id=${flippSiteId}`
export const uidKey = 'sc-widget-uid'
export const defaultServingSize = 4

export const ButtonStyle = {
  SINGLE: 'single',
  MULTI: 'multi'
}
